/**
 * 交流合作专区 案例分享 API
 */

import request from '@/utils/request'

export default {
  get: (data) => {
    return request.get(`/api/frLegalPlatform/web/case/sharing/page`, { params: data })
  },
  getDetail: (id) => {
    return request.get(`/api/frLegalPlatform/web/case/sharing/${id}`)
  }
}
